import { ENUM } from "../constants/enum";

export const isValidResponse = (res: any) => {
  if (res?.message === ENUM.API_RESPONSE_MESSAGE.SUCCESS) {
    return true;
  }
  return false;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};